export default __webpack_public_path__ + "static/media/resume.a8b7a170.pdf";